module.exports = __webpack_public_path__ + "static/media/comment-check.fec77c65.svg";